(function () {
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || (window.KROWN && KROWN.settings && KROWN.settings.shop_money_format) || '';
    if (!formatString || !formatString.match(placeholderRegex)) return String(cents || '');

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number === null) return '0';
      number = (number / 100.0).toFixed(precision);
      const parts = number.split('.');
      const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const centsAmount = parts[1] ? decimal + parts[1] : '';
      const iso = (window.KROWN && KROWN.settings && KROWN.settings.iso_code) || '';
      return dollarsAmount + centsAmount + iso;
    }

    let value = '';
    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  function getLocale(path, fallback) {
    const locales = window.KROWN && KROWN.settings && KROWN.settings.locales;
    if (!locales || !locales[path]) return fallback;
    return locales[path];
  }

  function updateCard(card) {
    const select = card.querySelector('[data-shop-look-size-select]');
    const variantInput = card.querySelector('[data-shop-look-variant-input]');
    const btn = card.querySelector('[data-js-product-add-to-cart]');
    const btnText = card.querySelector('[data-js-product-add-to-cart-text]');
    const price = card.querySelector('[data-shop-look-price]');
    const form = card.querySelector('form[data-type="add-to-cart-form"]');

    if (!variantInput || !btn || !btnText) return;

    const selectedOption = select ? select.options[select.selectedIndex] : null;
    const isAvailable = selectedOption
      ? selectedOption.dataset.available === 'true'
      : !btn.classList.contains('disabled');

    if (selectedOption) {
      variantInput.value = selectedOption.value;

      if (price && selectedOption.dataset.price) {
        let priceHtml = formatMoney(selectedOption.dataset.price, window.KROWN && KROWN.settings && KROWN.settings.shop_money_format);
        const comparePrice = parseInt(selectedOption.dataset.compareAtPrice || '0', 10);
        const currentPrice = parseInt(selectedOption.dataset.price || '0', 10);
        if (comparePrice > currentPrice) {
          priceHtml += '<del>' + formatMoney(comparePrice, window.KROWN && KROWN.settings && KROWN.settings.shop_money_format) + '</del>';
        }
        price.innerHTML = priceHtml;
      }
    }

    if (isAvailable) {
      btn.removeAttribute('disabled');
      btn.removeAttribute('aria-disabled');
      btn.classList.remove('disabled');
      btnText.textContent = getLocale('products_add_to_cart_button', 'Add to cart');
      if (form) form.classList.remove('disabled-cart');
    } else {
      btn.setAttribute('disabled', 'disabled');
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('disabled');
      btnText.textContent = getLocale('products_sold_out_variant', 'Sold out');
      if (form) form.classList.add('disabled-cart');
    }
  }

  function bindCartDrawer(formElement) {
    if (!formElement || formElement.dataset.shopLookDrawerBound === 'true') return;
    formElement.dataset.shopLookDrawerBound = 'true';

    formElement.addEventListener('add-to-cart', function () {
      if (document.body.classList.contains('template-cart')) return;
      if (!(window.KROWN && KROWN.settings && KROWN.settings.cart_action === 'overlay')) return;

      const siteCart = document.getElementById('site-cart');
      if (siteCart && typeof siteCart.show === 'function') {
        siteCart.show();
      }

      const recommendations = document.getElementById('cart-recommendations');
      if (recommendations && typeof recommendations.generateRecommendations === 'function') {
        recommendations.generateRecommendations();
      }
    });
  }

  function initCard(card) {
    if (card.dataset.shopLookInit === 'true') return;
    card.dataset.shopLookInit = 'true';

    const select = card.querySelector('[data-shop-look-size-select]');
    if (select) {
      ['mousedown', 'touchstart', 'pointerdown', 'click'].forEach(function (evtName) {
        select.addEventListener(evtName, function (event) {
          event.stopPropagation();
        });
      });

      select.addEventListener('change', function () {
        updateCard(card);
      });
    }

    bindCartDrawer(card.querySelector('product-form'));
    updateCard(card);
  }

  function init(root) {
    root.querySelectorAll('[data-shop-look-card]').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event && event.target) init(event.target);
  });
})();
